import { ReactNode } from 'react';
import { Box, CssBaseline } from '@material-ui/core';

const Layout = ({ children }: { children?: ReactNode }) => <>
    <CssBaseline />
    <Box style={{ padding: 0, flex: '1 0 auto', display: 'flex', flexDirection: 'column' }}>{children ?? ''}</Box>
</>

export default Layout;
